import DeviceUsageModal from './device-usage-modal.connect'

export default DeviceUsageModal
